import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ViewFinderIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8.75 2.55071C11.1875 2.88307 13.1169 4.81246 13.4493 7.25H10.5C10.2239 7.25 10 7.47386 10 7.75V8.25C10 8.52614 10.2239 8.75 10.5 8.75H13.4493C13.1169 11.1875 11.1875 13.1169 8.75 13.4493V10.5C8.75 10.2239 8.52614 10 8.25 10H7.75C7.47386 10 7.25 10.2239 7.25 10.5V13.4493C4.81246 13.1169 2.88307 11.1875 2.55071 8.75H5.5C5.77614 8.75 6 8.52614 6 8.25V7.75C6 7.47386 5.77614 7.25 5.5 7.25H2.55071C2.88307 4.81246 4.81246 2.88307 7.25 2.55071V5.5C7.25 5.77614 7.47386 6 7.75 6H8.25C8.52614 6 8.75 5.77614 8.75 5.5V2.55071Z"
		></path>
	</svg>
))
